import "core-js/modules/web.url-search-params.size.js";
import * as Sentry from "@sentry/nextjs";
import "navigator.locks";
import axios from "axios";
import Cookies from "js-cookie";
import { config } from "shared/data";
export const logout = () => {
  const url = new URL(`${config.account.scmpAccountHost}/logout`);
  url.searchParams.set("destination", encodeURIComponent(location.href));
  location.href = url.toString();
};
export const refreshToken = async () => {
  const url = `${config.account.scmpAccountHost}/refreshToken`;
  const postPromise = async () => {
    try {
      return await axios.post(url, null, {
        withCredentials: true
      });
    } catch (error) {
      var _response$data;
      const {
        response
      } = error;
      const scmpAtExp = Cookies.get("scmp_at_exp");
      const scmpRtSub = Cookies.get("scmp_rt_sub");
      Sentry.captureException(error, {
        extra: {
          response,
          scmpAtExp,
          scmpRtSub
        }
      });
      if (response && ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.message) === "missing scmp_at or scmp_rt") {
        logout();
      }
    }
  };
  // Ensure no other refresh token will be called
  return navigator.locks.request("refreshToken", {
    ifAvailable: true
  }, async lock => {
    if (!lock) return;
    await postPromise();
  });
};